<ng-template #body>
  <div class="p-6 flex flex-col md:flex-row gap-4 bg-gray-50/30 overflow-hidden flex-1 min-h-0">
    <div class="flex flex-col flex-1 border border-gray-200 rounded-lg bg-white shadow-sm overflow-hidden max-h-[280px]">
      <div class="flex items-center gap-3 px-4 py-3 bg-gray-50 border-b border-gray-200 shrink-0">
        <div class="relative flex items-center justify-center w-5 h-5 cursor-pointer">
          <input
            type="checkbox"
            class="peer appearance-none w-5 h-5 border border-gray-300 rounded bg-white checked:bg-[var(--primary-500)] checked:border-[var(--primary-500)] cursor-pointer transition-all"
            [checked]="isAllSelected(filteredAvailable())"
            (change)="toggleSelectAll(filteredAvailable(), $event)"
          />
          <i class="pi pi-check absolute text-white text-[10px] font-bold opacity-0 peer-checked:opacity-100 pointer-events-none"></i>
        </div>
        <span class="font-bold text-gray-700 text-sm select-none">Available</span>
      </div>

      <div class="p-3 border-b border-gray-100 shrink-0">
        <div class="relative">
          <input
            placeholder="{{ allowBulkSearch && bulkSearchMode ? 'Paste keys separated by comma..' : 'Search..' }}"
            [(ngModel)]="searchAvailable"
            (ngModelChange)="onBulkSearchInput()"
            class="w-full pl-3 pr-8 py-2 text-xs border border-gray-300 rounded-md focus:outline-none focus:border-[var(--primary-500)] focus:ring-1 focus:ring-[var(--primary-500)] transition-all"
          />
          <i class="pi pi-search absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 text-xs"></i>
        </div>

        <div *ngIf="allowBulkSearch" class="flex items-center gap-2 mt-2">
          <button
            type="button"
            role="switch"
            [attr.aria-checked]="bulkSearchMode"
            aria-label="Bulk search"
            (click)="toggleBulkSearchMode()"
            class="relative inline-flex h-5 w-9 shrink-0 items-center rounded-full transition-colors focus:outline-none"
            [ngClass]="bulkSearchMode ? '!bg-[var(--primary-500)]' : 'bg-gray-300'"
          >
            <span
              class="inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform"
              [ngClass]="bulkSearchMode ? 'translate-x-4' : 'translate-x-0.5'"
            ></span>
          </button>
          <span class="text-xs text-gray-600 select-none">Bulk search (paste comma-separated keys)</span>
        </div>

        <div *ngIf="allowBulkSearch && bulkSearchMode && bulkSearchFeedback" class="text-xs text-gray-500 mt-1 select-none">
          {{ bulkSearchFeedback }}
        </div>
      </div>

      <div class="flex-1 overflow-y-auto custom-scrollbar p-2 bg-white">
        <ng-container *ngIf="!loading; else leftListSkeleton">
          <ng-container *ngFor="let role of filteredAvailable()">
            <div class="flex items-center gap-3 px-3 py-2 rounded hover:bg-gray-50 cursor-pointer relative" (click)="role.selected = !role.selected">
              <div class="relative flex items-center justify-center w-5 h-5">
                <input type="checkbox" [(ngModel)]="role.selected" class="appearance-none w-5 h-5 border rounded bg-white cursor-pointer transition-all" [ngStyle]="{'background-color': role.selected ? 'var(--primary-500)' : 'white', 'border-color': role.selected ? 'var(--primary-500)' : ''}" />
                <i class="pi pi-check absolute text-white text-[10px] font-bold pointer-events-none" [style.opacity]="role.selected ? '1' : '0'"></i>
              </div>
              <div class="text-sm text-gray-700">{{ role.name }}</div>
            </div>
          </ng-container>

          <div *ngIf="filteredAvailable().length === 0" class="flex flex-col items-center justify-center h-full text-gray-400 pb-8">
            <span class="text-xs italic">No roles found</span>
          </div>
        </ng-container>

        <ng-template #leftListSkeleton>
          <div *ngFor="let i of [1,2,3,4,5,6]" class="h-3 bg-gray-200 rounded mb-3 w-full"></div>
        </ng-template>
      </div>
    </div>

    <div class="flex flex-row md:flex-col justify-center items-center gap-3 shrink-0">
      <div class="flex flex-row md:flex-col gap-3">
        <button pButton type="button" icon="pi pi-arrow-right" class="!bg-[var(--primary-500)] !border-[var(--primary-500)] !text-white w-10 h-10 rounded-lg shadow-md" [disabled]="loading || !hasSelected(available)" (click)="moveToSelected()"></button>
        <button pButton type="button" icon="pi pi-arrow-left" class="!bg-[var(--primary-500)] !border-[var(--primary-500)] !text-white w-10 h-10 rounded-lg shadow-md" [disabled]="loading || !hasSelected(selected)" (click)="moveToAvailable()"></button>
      </div>
    </div>

    <div class="flex flex-col flex-1 border border-gray-200 rounded-lg bg-white shadow-sm overflow-hidden max-h-[280px] ">
      <div class="flex items-center gap-3 px-4 py-3 bg-gray-50 border-b border-gray-200 shrink-0">
        <div class="relative flex items-center justify-center w-5 h-5 cursor-pointer">
          <input type="checkbox" class="peer appearance-none w-5 h-5 border border-gray-300 rounded bg-white" [checked]="isAllSelected(filteredSelected())" (change)="toggleSelectAll(filteredSelected(), $event)" />
        </div>
        <span class="font-bold text-gray-700 text-sm select-none">Selected</span>
      </div>

      <div class="p-3 border-b border-gray-100 shrink-0">
        <div class="relative">
          <input placeholder="Search.." [(ngModel)]="searchSelected" class="w-full pl-3 pr-8 py-2 text-xs border border-gray-300 rounded-md" />
          <i class="pi pi-search absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 text-xs"></i>
        </div>
      </div>

      <div class="flex-1 overflow-y-auto custom-scrollbar p-2 bg-white">
        <ng-container *ngIf="!loading; else rightListSkeleton">
          <ng-container *ngFor="let role of filteredSelected()">
            <div class="flex items-center gap-3 px-3 py-2 rounded hover:bg-gray-50 cursor-pointer relative" (click)="role.selected = !role.selected">
              <div class="relative flex items-center justify-center w-5 h-5">
                <input type="checkbox" [(ngModel)]="role.selected" class="appearance-none w-5 h-5 border rounded bg-white cursor-pointer transition-all" [ngStyle]="{'background-color': role.selected ? 'var(--primary-500)' : 'white', 'border-color': role.selected ? 'var(--primary-500)' : ''}" />
                <i class="pi pi-check absolute text-white text-[10px] font-bold pointer-events-none" [style.opacity]="role.selected ? '1' : '0'"></i>
              </div>
              <div class="text-sm text-gray-700">{{ role.name }}</div>
            </div>
          </ng-container>

          <div *ngIf="filteredSelected().length === 0" class="flex flex-col items-center justify-center h-full text-gray-400 pb-8">
            <span class="text-xs italic">No roles found</span>
          </div>
        </ng-container>

        <ng-template #rightListSkeleton>
          <div *ngFor="let i of [1,2,3,4,5,6]" class="h-3 bg-gray-200 rounded mb-3 w-full"></div>
        </ng-template>
      </div>
    </div>
  </div>
</ng-template>

<app-modal-wrapper
  *ngIf="isDialog"
  [title]="title"
  [isDirty]="hasChanges()"
  [formValid]="true"
  [showSaveButton]="true"
  (save)="onSaveDialog()"
  (closeRequest)="closeDialog()"
>
  <ng-container *ngTemplateOutlet="body"></ng-container>
</app-modal-wrapper>

<ng-container *ngIf="!isDialog">
  <ng-container *ngTemplateOutlet="body"></ng-container>
</ng-container>
